import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
type HintStage = 'move' | 'kick' | 'interact' | 'done';
const Key = ({
  children
}: {
  children: React.ReactNode;
}) => <span className="inline-block min-w-[28px] px-2 py-1 border-2 border-white/80 bg-black/60 text-white font-bold text-sm tracking-wider rounded-sm" style={{
  boxShadow: '0 2px 0 rgba(255,255,255,0.3), inset 0 0 8px rgba(255,255,255,0.15)'
}} data-id="element-164">
    {children}
  </span>;
export function TutorialHints() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  const [stage, setStage] = useState<HintStage>('move');
  useEffect(() => gameStore.subscribe(setState), []);
  // Advance stages based on story flags
  useEffect(() => {
    if (state.phase !== 'playing') return;
    if (stage === 'move' && state.storyFlags.has_moved) setStage('kick');else if (stage === 'kick' && state.storyFlags.has_kicked) setStage('interact');else if (stage === 'interact' && state.storyFlags.has_interacted) setStage('done');
  }, [state.storyFlags, state.phase, stage]);
  if (state.phase !== 'playing' || stage === 'done' || state.isGameOver) return null;
  if (state.dialogueQueue.length > 0) return null; // Don't cover dialogue
  return <div className="absolute bottom-32 md:bottom-36 left-1/2 -translate-x-1/2 pointer-events-none z-30" data-id="element-165">
      <AnimatePresence mode="wait" data-id="element-166">
        {stage === 'move' && <motion.div key="move" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="text-center" data-id="element-167">
            <div className="flex justify-center items-end gap-1 mb-3" data-id="element-168">
              <Key data-id="element-169">W</Key>
            </div>
            <div className="flex justify-center gap-1" data-id="element-170">
              <Key data-id="element-171">A</Key>
              <Key data-id="element-172">S</Key>
              <Key data-id="element-173">D</Key>
            </div>
            <div className="text-white/80 uppercase tracking-[0.3em] text-xs mt-3" data-id="element-174">
              Move
            </div>
          </motion.div>}

        {stage === 'kick' && <motion.div key="kick" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="text-center" data-id="element-175">
            <div className="flex justify-center items-center gap-3 mb-2" data-id="element-176">
              <Key data-id="element-177">SPACE</Key>
            </div>
            <div className="text-white/80 uppercase tracking-[0.3em] text-xs" data-id="element-178">
              Kick
            </div>
            <div className="text-gray-400 text-[11px] italic mt-1" data-id="element-179">
              Walk close to something and kick it
            </div>
          </motion.div>}

        {stage === 'interact' && <motion.div key="interact" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="text-center" data-id="element-180">
            <div className="flex justify-center items-center gap-3 mb-2" data-id="element-181">
              <Key data-id="element-182">E</Key>
            </div>
            <div className="text-white/80 uppercase tracking-[0.3em] text-xs" data-id="element-183">
              Stomp · Talk · Enter Portal
            </div>
            <div className="text-gray-400 text-[11px] italic mt-1" data-id="element-184">
              Context-sensitive. Mostly violent.
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}